import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
    selector: '[svgIconHost]',
    standalone: false
})
export class SvgIconHostDirective {
    constructor(public viewContainerRef: ViewContainerRef) { }
}
